import axios from "axios";

// axios.defaults.baseURL = 'http://wechat.ejuyun.com:1003/api/';
// axios.defaults.baseURL = 'http://cssdtest.ejuyun.com:1009/api/';
axios.defaults.baseURL = 'http://tzfr.fengrunxidi.cn:82/api/';
const basicData = {
    Phone: '133xxxx6393',
    MC: '泰州峰润洗涤有限公司'
}

axios.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        // any status code that lie within the range of 2xx cause this function to trigger
        const data = response.data;
        if (data.status !== 0) {

        }
        return response.data;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export { axios, basicData };